import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8cad1844.js';
import { I as Icon } from './chunk-ea9bc877.js';
export { I as BIcon } from './chunk-ea9bc877.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Icon);
  }
};
use(Plugin);

export default Plugin;
